<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.59729 1.15309L0.102219 14.6149C-0.101647 15.3988 0.369153 16.1996 1.15309 16.4028L14.6149 19.8978C15.3988 20.1017 16.1996 19.6309 16.4028 18.847L19.8978 5.38515C20.1017 4.60122 19.6309 3.80042 18.847 3.59729L5.38515 0.102219C4.60122 -0.101647 3.80042 0.369153 3.59729 1.15309ZM8.83475 8.01709L11.983 8.83475L11.1653 11.983L8.01709 11.1653L8.83475 8.01709Z" />
    </svg>
</template>
